import { Injectable } from '@angular/core';
import { BulkActionDialogComponent } from '@app/shared/components/bulk-actions/bulk-action-dialog/bulk-action-dialog.component';
import { BulkActionProcessingResults } from '@app/shared/components/bulk-actions/models/bulk-action-dialog-result';
import { BulkActionOptions } from '@app/shared/components/bulk-actions/models/bulk-action-options';
import { DialogService } from '@app/shared/dialog/dialog.service';

@Injectable({
  providedIn: 'root',
})
export class BulkActionExecutorService {
  constructor(private dialogService: DialogService) {}

  executeAction<T>(options: BulkActionOptions<T>): Promise<BulkActionProcessingResults | null> {
    return new Promise((resolve) => {
      if (options.assert != null) {
        const assertion = options.assert(options.entries);

        if (assertion?.valid === false) {
          this.dialogService.openInfo(assertion.text!, options.title, 'warning').onDismiss(() => {
            resolve({
              allFailed: false,
              allSucceeded: false,
              assertionFailed: true,
              errors: [],
              results: [],
            });
          });
        } else {
          this.runAction(options).then((result) => {
            resolve(result);
          });
        }
      } else {
        this.runAction(options).then((result) => {
          resolve(result);
        });
      }
    });
  }

  private runAction<T>(options: BulkActionOptions<T>): Promise<BulkActionProcessingResults | null> {
    return new Promise((resolve) => {
      this.dialogService
        .open(BulkActionDialogComponent, {
          size: 'lg',
        })
        .withInput(options)
        .onClose((output) => {
          resolve(output.result);
        });
    });
  }
}
